import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import BlankState from '../../../components/BlankState';
import DataTable from '../../../components/DataTable';
import Page from '../../../components/Page';

import Modal from '../../../components/Modal';
import CertificatePreview from '../../../pages/buy/CertificatePreview';

import { fetchFilteredPolicies } from '../../../actions/policies';
import { printCertificate } from '../../../utils/apiService';

class Certificates extends Component{

	constructor(props){
		super(props);

		this.state = {
            policyFilter: {
				insurer: this.props.user.userInfo.insurer
			},

            active_certificate: {}
        };
	}

	componentDidMount(){
        this.props.fetchFilteredPolicies();
    }

    showCertificate = (certificate) => {
        this.setState({
            active_certificate: certificate
        });
    }

    printCert = (certificate) => {
        let certId = certificate.id;
        
        printCertificate(certId)
        .then((response)=>{
            let data = response.request.responseURL
            let link = document.createElement('a');

            link.href = data;
            link.download="file.pdf";
            link.click();
            setTimeout(function(){
                window.URL.revokeObjectURL(data)
                ,100
            })
        });
    }
	
	render(){
        const { active_certificate } = this.state;
        const { filteredPolicies, policies_loading } = this.props.policies;

		return(
			<Page isAdminPage={ true } pageTitle="Certificates">
				<div className="card">
                    {
                        filteredPolicies.length > 0 ?

                        <DataTable 
                            tableId="certificates-table"
                            columnTitles={ ["Policy No.", "Proposer Name", "Insured Name", 
                                "Insured Email", "ICC Class", "Customs Verified", "Start Date", "Actions"] }>

                        {
                            filteredPolicies.map((certificate, index)=>{

                                const { policy_number, proposer_name, insured_data, institute_cargo_clause, is_verified, 
                                    start_date } = certificate;

                                return(
                                    <tr key={ index } >
                                        <td>{ policy_number }</td>
                                        <td>{ proposer_name || '-' }</td>
                                        <td>{ insured_data.name || '-' }</td>
                                        <td>{ insured_data.email || '-' }</td>
                                        <td>{ institute_cargo_clause }</td>
                                        <td>
										{ 
											is_verified === true ? 
												<span className="label label-success">Verified</span>
											: 
												<span className="label label-warning">Not Verified</span>
										}
										</td>
                                        <td>{ moment(start_date).format('MMM Do, YYYY') }</td>
                                        <td>
                                            <button
                                                data-toggle="modal" 
                                                data-target=".view-certificate-modal"
                                                className="btn btn-warning btn-xs"
                                                onClick={ ()=>{ this.showCertificate(certificate) } }>
                                                <i className="icon ion-eye"></i> View
                                            </button>
                                            <button
                                                className="btn btn-success btn-xs"
                                                onClick={ ()=>{ this.printCert(certificate) } }>
                                                <i className="icon ion-ios-cloud-download-outline"></i> Print
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </DataTable>
                    :
                        <BlankState 
                            data={ filteredPolicies } 
                            dataName="Certificates" 
                            isDataLoading={ policies_loading } />
                    }

                    <Modal 
                        title="View Certificate"
                        className="view-certificate-modal"
                        closable={ true }>

                        {
                            active_certificate.hasOwnProperty('id') ?
                                
                                <CertificatePreview quote={ active_certificate } />
                            :
                                null
                        }
                    </Modal>
                </div>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    policies: state.policies
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ fetchFilteredPolicies }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Certificates);


// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/Certificates.jsx